var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyVoucher = function SvgEmptyVoucher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 173,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF9",
    d: "M86.935 146.297c34.626 0 62.698-28.158 62.698-63.015s-28.196-63.015-62.698-63.015c-34.625 0-62.697 28.158-62.697 63.015s28.072 63.015 62.697 63.015M145.552 41.975c2.8 0 5.07-2.277 5.07-5.086s-2.27-5.086-5.07-5.086-5.071 2.277-5.071 5.086 2.27 5.086 5.071 5.086M152.971 22.128a3.47 3.47 0 0 0 3.463-3.474 3.47 3.47 0 0 0-3.463-3.473 3.47 3.47 0 0 0-3.462 3.473 3.47 3.47 0 0 0 3.462 3.474M27.577 41.85a3.47 3.47 0 0 0 3.462-3.472 3.47 3.47 0 0 0-3.462-3.474 3.47 3.47 0 0 0-3.463 3.474 3.47 3.47 0 0 0 3.463 3.473M6.43 108.835c3.552 0 6.431-2.888 6.431-6.45s-2.88-6.45-6.43-6.45c-3.552 0-6.431 2.888-6.431 6.45s2.879 6.45 6.43 6.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-voucher_svg__a)",
    d: "M182.488 63.497h-6.135v-6.154h-5.259v6.154h-6.135v5.451h6.135v6.154h5.259v-6.154h6.135z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-voucher_svg__b)",
    d: "M80.96 5.26h-5.244V0H71.22v5.26h-5.244v4.66h5.244v5.261h4.496v-5.26h5.244z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-voucher_svg__c)",
    d: "M19.233 57.747h-4.48v-4.495h-3.841v4.495H6.43v3.98h4.48v4.496h3.842v-4.495h4.48z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-voucher_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-voucher_svg__e)",
    d: "M131.039 71.13 118.656 40.8c-2.208-5.393-7.967-8.474-13.631-7.223L73.06 40.51c-2.688.578-4.992 2.407-6.336 4.815l-30.43 58.158c-1.247 2.407-.383 5.489 2.112 6.74l55.1 29.08c2.4 1.252 5.472.385 6.719-2.119l30.43-58.158c1.344-2.407 1.44-5.296.384-7.896m-30.622-12.229c-3.935-2.022-5.471-6.932-3.36-10.88 2.016-3.948 6.912-5.489 10.848-3.37 3.935 2.022 5.471 6.932 3.359 10.88-2.015 3.948-6.911 5.489-10.847 3.37"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB6C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M104.353 51.487c25.054-12.999 34.941-32.353 21.886-40.73s-25.918 0-29.181 24.361"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB2C5",
    d: "M97.815 93.45c1.695.94 3.952.29 4.89-1.41s.29-3.964-1.405-4.905-3.952-.291-4.89 1.41c-1.005 1.82-.41 3.896 1.405 4.904M88.157 97.89l-1.574-.873c.276-3.654-2.631-6.696-6.22-6.785-1.357-.12-2.862.314-3.95 1.138l-1.573-.874c3.409-3.025 8.84-2.548 11.667.926 1.293 1.67 2.063 4.001 1.65 6.469M73.602 80.005c1.695.94 3.952.29 4.89-1.41s.29-3.964-1.405-4.905-3.952-.29-4.89 1.41c-.884 1.888-.29 3.963 1.405 4.904"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-voucher_svg__a",
    x1: 173.725,
    x2: 173.725,
    y1: 57.96,
    y2: 67.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-voucher_svg__b",
    x1: 73.469,
    x2: 73.469,
    y1: 0.527,
    y2: 9.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-voucher_svg__c",
    x1: 12.833,
    x2: 12.833,
    y1: 53.703,
    y2: 60.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-voucher_svg__e",
    x1: 83.711,
    x2: 83.711,
    y1: 30.835,
    y2: 141.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-voucher_svg__d",
    width: 140.027,
    height: 150.571,
    x: 13.729,
    y: 22.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4033_169588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4033_169588",
    result: "shape"
  })))));
};
export default SvgEmptyVoucher;